module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Regular.0e1821fd.ttf";